import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '@environments/environment';

/**
 * Guard to protect digital assistant route based on feature flag.
 * Redirects to home if digital assistant is disabled.
 */
export const digitalAssistantGuard: CanActivateFn = () => {
    const router = inject(Router);

    if (!environment.featureFlags?.digitalAssistant?.enabled) {
        router.navigate(['/']);
        return false;
    }

    return true;
};
